import React from "react";

/**
 * Render a small (w-5 h-5) icon for the given file type. The icon assets
 * live in `/public` so we reference them by URL string rather than
 * import-and-bundle.
 *
 * Used by the Forms list, the Forms file picker, and the Questionnaire
 * list. Other places (UploadModal, IndividualQuestionnairePage,
 * Project.jsx) use larger sizes or string-returning variants — they keep
 * their own helpers.
 */
export const getFileIcon = (fileType) => {
  const type = fileType?.toLowerCase();
  return (
    <img
      src={
        type === "pdf"
          ? "/pdff.svg"
          : type === "xlsx" || type === "xls"
          ? "/Xls.svg"
          : type === "docx"
          ? "/docX.svg"
          : type === "csv"
          ? "/CSV.svg"
          : "/TXT.svg"
      }
      className="w-5 h-5 flex-shrink-0"
      alt={`${type} icon`}
    />
  );
};

/**
 * Tag-pill background/border classes for the document-type chip rendered
 * in file picker rows. Returns Tailwind class strings.
 */
export const getTagStyle = (tag) => {
  const t = (tag || "").toLowerCase();
  if (t === "urgent") return "bg-purple-100 text-purple-700 border-purple-300";
  if (t === "budget") return "bg-[#ecfccb] text-[#4d7c0f] border-[#d9f99d]";
  if (t === "questionnaire") return "bg-red-100 text-red-700 border-red-200";
  if (t === "t&c") return "bg-yellow-100 text-yellow-700 border-yellow-200";
  if (t === "sales") return "bg-pink-100 text-pink-700 border-pink-200";
  if (t === "rfp") return "bg-green-100 text-green-700 border-green-200";
  return "bg-gray-100 text-gray-600 border-gray-200";
};
